/**
 * @file Helpers for API field validation error payloads.
 */

export type ApiFieldErrors = Record<string, string | string[]>;

export interface ApiValidationError extends Error {
  errors: ApiFieldErrors;
  success?: boolean;
}

export function isApiValidationError(error: unknown): error is ApiValidationError {
  return (
    error !== null &&
    typeof error === 'object' &&
    'errors' in error &&
    typeof (error as ApiValidationError).errors === 'object' &&
    (error as ApiValidationError).errors !== null &&
    !Array.isArray((error as ApiValidationError).errors)
  );
}

export function getApiFieldError(errors: ApiFieldErrors, field: string): string | undefined {
  const value = errors[field];
  if (value === undefined || value === null) return undefined;
  if (Array.isArray(value)) return value.filter(Boolean).join(' ');
  return String(value);
}

export function apiErrorsToFieldMap(errors: ApiFieldErrors): Record<string, string> {
  const map: Record<string, string> = {};
  for (const [field, value] of Object.entries(errors)) {
    const msg = getApiFieldError(errors, field);
    if (msg) map[field] = msg;
  }
  return map;
}
